import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ClusterLinksSection from './components/ClusterLinksSection';
import WhyManagerNegotiates from './components/WhyManagerNegotiates';
import ManagerVsLeader from './components/ManagerVsLeader';
import NegotiationRoles from './components/NegotiationRoles';
import WhenToStrengthen from './components/WhenToStrengthen';
import NegotiationAsTool from './components/NegotiationAsTool';
import NegotiationSkills from './components/NegotiationSkills';
import UpwardNegotiations from './components/UpwardNegotiations';
import StrongEmployees from './components/StrongEmployees';
import UnderPressure from './components/UnderPressure';
import ManagerMistakes from './components/ManagerMistakes';
import HowPracticeGoes from './components/HowPracticeGoes';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import FormatsSection from './components/FormatsSection';
import HowProgramGoes from './components/HowProgramGoes';
import AboutTrainer from './components/AboutTrainer';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';
import FinalCTA from './components/FinalCTA';
import Footer from '@/components/feature/Footer';

const navLinks = [
  { label: 'Навыки', target: 'skills' },
  { label: 'Программа', target: 'process' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function LeaderInNegotiationsPage() {
  return (
    <>
      
      <SeoTitle title="Руководитель в переговорах | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={navLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <ClusterLinksSection />
        <WhyManagerNegotiates />
        <ManagerVsLeader />
        <NegotiationRoles />
        <WhenToStrengthen />
        <NegotiationAsTool />

        <div id="skills">
          <NegotiationSkills />
        </div>

        <UpwardNegotiations />
        <StrongEmployees />
        <UnderPressure />
        <ManagerMistakes />
        <HowPracticeGoes />
        <WhyProgramsWork />

        <div id="results">
          <CompanyResults />
        </div>

        <FormatsSection />

        <div id="process">
          <HowProgramGoes />
        </div>

        <AboutTrainer />
        <FAQSection />
        <ReadNextSection />
        <FinalCTA />
        <Footer />
      </div>
    </>
  );
}